var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form-group"},[_c('page-title',{attrs:{"showTitle":false,"title":_vm.$t('calendar.title')}})],1),_c('calendar',{attrs:{"viewType":_vm.viewType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }